import { AND, ROUNDUP, XIF } from '../utils/excel-functions-utils';
import tclocal from './ter-consts-local-lib';
import { _getParamsFromLib } from './ter-params-utils';
import { _virbom_manipulator } from '../utils/frfr-virbom-manipulator-utils';
import { virbomCounter } from '../utils/frfr-virbom-counter-utils';
import { MINUS } from '../utils/frfr-string-consts';
import { draftel_codecs_pack_terkk$kadica } from './ter-draftel-codec-lib-terkk-kadica';
import { SINGLE_PIECE_PER_NEXT_OPERATION_UNIT } from './virtel-consts';
import { protobomp_manipulator } from '../utils/frfr-protobomp-utils';
import { terProtobompUtils_make_protobomp_manifest_terkk_latest, terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP, terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM, terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_MATERIJAL } from './ter-protobomp-utils';
import { terUtilsNumberRoundUp, terUtils_get_naziv_materijala_by_ident, terUtils_izracunaj_povrsinu_materijala_lim } from './ter-utils';
import { _getParamsFromLibMaterijalLimParams } from './ter-materijal-utils';
import { js_utils } from '../utils/frfr-js-utils';


export const derivat_kadica_pripremi_pods_input_inherited_za_draftel = (virtel_m) => {
  // returnujemo jednostavan objekat sa svim ulaznim velicinama za derivat formulu
  const pods_input_inherited = {
    ...draftel_codecs_pack_terkk$kadica.default_pods_input_state(),
    // msirinaunutrasnja: virtel_m.msirinaunutrasnja,
    // vrstaprofila: virtel_m.vrstaprofila,
    msirinaunutrasnjaizmedjuosnovnih: virtel_m.msirinaunutrasnjaizmedjuosnovnih,
    siframodula: virtel_m.siframodula,
  };
  return pods_input_inherited;
};


//
export const _derivat_terkk_kadica_v2_izracunaj_materijale = (pods_input, cparams_combined) => {
  //
  let kadica_materijal_lim = null;
  //
  if (cparams_combined && cparams_combined.terkk_materijal_ident) { // validate cparams TODO
    // By cparmas
    if (js_utils.is_string_not_empty(cparams_combined.terkk_materijal_ident.kadica_materijal_lim_default)) { // validate cparams TODO
      // By cparmas
      kadica_materijal_lim = cparams_combined.terkk_materijal_ident.kadica_materijal_lim_default;
    }
  }
  //
  return {
    kadica_materijal_lim,
  };
};


/*
export const _derivat_kadica_duzina = (msirinaunutrasnja, vrstaprofila) => {
  // koristimo msirinaunutrasnja i vrstu profila 50 ili 70 u toj fomuli
  let duzina = 0;
  const zazor = 1; // Zazor = 1 mm
  const tervrstaprofila_50_ili_70 = _derivatModulProfil_extract_50_ili_70_by_vrstaprofila(vrstaprofila);
  if (tervrstaprofila_50_ili_70 === '50') {
    // Ukoliko je profil 50 onda se unutrasnje sirine modula oduzima 2*zazor.
    duzina = msirinaunutrasnja - (2 * zazor);
  } else if (tervrstaprofila_50_ili_70 === '70') {
    // Ukoliko je profil 70 onda se unutrasnje sirine modula oduzima (2*15)+(2*zazor).
    duzina = msirinaunutrasnja - ((2 * 15) + (2 * zazor));
  }
  return duzina;
};
*/
export const _derivat_kadica_duzina = (msirinaunutrasnjaizmedjuosnovnih) => {
  //NOVO 2023-06-16
  const zazor = 1; // Zazor = 1 mm
  const duzina = msirinaunutrasnjaizmedjuosnovnih - (2 * zazor);
  return duzina;
};


export const derivatPoluproizvod_kadica_naziv = (tip, duzina, sirina, odvodkondenzata) => {
  const E2 = tip;
  const E4 = duzina;
  const E5 = sirina;
  const E6 = odvodkondenzata;
  const naziv = "KADICA " + E2 + " " + E4 + " x " + E5 + " ODVOD " + E6 + '"';
  return naziv;
};


export const derivatPoluproizvod_kadica_broj_crteza = (tip, duzina, sirina, odvodkondenzata) => {
  // const DELIMETER = MINUS; // '-'
  const _prefix = "P01-18";
  let _tip = "A"; // STANDARDNA
  if (tip === 'PLITKA') {
    _tip = "B"; // PLITKA
  }
  let _odvodkondenzata = "DN25"; // 1"
  if (odvodkondenzata === '3/4') {
    _odvodkondenzata = "DN20"; // 3/4"
  }
  const broj_crteza = _prefix + MINUS + _tip + MINUS + duzina + 'x' + sirina + MINUS + _odvodkondenzata;
  return broj_crteza;
};


const derivatPoluproizvod_kadica_mat_lim_kolicina = (tip, E4, E5) => {
  let kolicina;
  if (tip === "STANDARDNA") {
    kolicina = ROUNDUP((E5 + 176) * (E4 + 131) * 0.000001, 2); // Standardna
  } else if (tip === "PLITKA") {
    kolicina = ROUNDUP((E5 + 77) * (E4 + 58) * 0.000001, 2); // Plitka
  }
  return kolicina;
};


/*
export const derivatPoluproizvod_kadica_dopuni = (p) => {
  // SPECIJALNI KORAK
  // Poluproizvodu dodajemo neke podatke koji su mu potrebni!

  let kadica = {
    ...p,
    ..._getParamsFromLib("terkk$kadica"),
    naziv: derivatPoluproizvod_kadica_naziv(p.tip, p.duzina, p.sirina, p.odvodkondenzata)
  };
  return kadica;
};
*/


//
export const _derivat_terkk_kadica_v2_pbnode_dirty_enrich = (pbnode_state_ref, protobomp_superdata, is_init) => {
  // DIRTY ENRICH
  // TODO ...props super superProps
  // console.log('item_ref, protobomp_superdata', item_ref, protobomp_superdata);
  const item = pbnode_state_ref;
  const family = item.pbnode_family;
  let povrsina = -1;
  let _cnc = null;
  let _naziv = null;
  let _materijal = '?'; // item.identmaterijala
  let _naziv_profil_komore_50_ili_70 = '?';
  let _naziv_tip_kadice = '?';
  let _tip_klizaca_abc = '?';
  let _tip_kadice = '?';
  let _strana_maske = '?';
  let _sufix = '?';
  let _visina_20_ili_35 = -1;
  /*
  Gde su: 

  */
  //
  const _mat_params = _getParamsFromLibMaterijalLimParams(item.identmaterijala);
  if (is_init === true) {
    if (typeof _mat_params.naziv === 'string') {
      item.naziv_materijala = _mat_params.naziv; // DIRTY
    } else {
      item.naziv_materijala = ''; // DIRTY
    }
  }
  const _tipmetalalima = _mat_params?.naziv_materijala;
  if (_tipmetalalima === "Prohrom") {
    _materijal = "SS";
  }
  if (_tipmetalalima === "Pocinkovani") {
    _materijal = "GS";
  }
  //
  const {
    tip, duzina, sirina, odvodkondenzata, ter_visedelni_koliko_delova,
  } = protobomp_superdata;
  //

  //
  if (true) {
    // sklop
    if (family === 'terkk$kadica_v2/SKLOP_KADICA') {
      // naziv primer: KADICA STANDARDNA 578 x 1000 ODVOD 1"
      _naziv = derivatPoluproizvod_kadica_naziv(tip, duzina, sirina, odvodkondenzata);
      item.tip = tip; // DIRTY
      item.duzina = duzina; // DIRTY
      item.sirina = sirina; // DIRTY
      item.odvodkondenzata = odvodkondenzata; // DIRTY
      item.ter_visedelni_koliko_delova = ter_visedelni_koliko_delova; // DIRTY
    }
    //
    if (family === 'terkk$kadica_v2/LIM' || family === 'terkk$kadica_v2/LIM_1_2' || family === 'terkk$kadica_v2/LIM_2_2') {
      _naziv = derivatPoluproizvod_kadica_naziv(tip, duzina, sirina, odvodkondenzata);
      _cnc = derivatPoluproizvod_kadica_broj_crteza(tip, duzina, sirina, odvodkondenzata);
      if (family === 'terkk$kadica_v2/LIM_1_2') {
        item.odvodkondenzata = odvodkondenzata; // DIRTY
        _naziv += ' P1';
        _cnc += '-P1';
        item.ter_koji_deo_visedelnog = 1; // DIRTY
      }
      if (family === 'terkk$kadica_v2/LIM_2_2') {
        _naziv += ' P2';
        _cnc += '-P2';
        item.ter_koji_deo_visedelnog = 2; // DIRTY
      }
      item.tip = item.identmaterijala; // DIRTY
      /*
      dimenzija1: sirina,
      dimenzija2: duzina,
      razvijenamera1:sirina_razvijena,
      razvijenamera2:duzina_razvijena,
      */
      povrsina = item.razvijenamera1 * item.razvijenamera2;
    }
    //
    //
  }
  // 
  if (povrsina > -1) {
    item.povrsina = terUtilsNumberRoundUp((povrsina / 1000000), 2); // konvertovana u m2 i zaokruzeno na 2 decimale // DIRTY
  }
  if (_cnc) {
    item.cnccrtez = _cnc; // DIRTY
  }
  if (_naziv) {
    item.naziv = _naziv; // DIRTY
  }
  //
  return item;
};


//
export const _derivat_terkk_kadica_v2_izracunaj_za_step_protobomp = (state, pods_input) => {
  //
  const {
    siframodula,
  } = pods_input;
  const {
    tip, duzina, sirina, odvodkondenzata,
    kolicina,
    kadica_materijal_lim,
  } = state;
  //
  let duzina_dodatak_za_savijanje;
  let sirina_dodatak_za_savijanje;
  let p1_raz_duzina = 0;
  let p1_raz_sirina = 0;
  let p2_raz_duzina = 0;
  let p2_raz_sirina = 0;
  let korektivni_deo = 0;
  let p1_dim_duzina = -1;
  let p2_dim_duzina = -1;
  let p1_dim_sirina = -1;
  let p2_dim_sirina = -1;
  /*
  Razvijene mere kadice računaju se po sledećoj formuli:

  Standardna kadica:
  Širina kadice= Širina kadice+176,1
  Dužina kadice= Dužina + 128,99

  Plitka kadica :
  Širina kadice= Širina kadice+77,15
  Dužina kadice= Dužina + 60,63
  */
  if (tip === "PLITKA") {
    // ZA PLITKU
    /*
    Plitka kadica :
    RAZŠirina kadice= Širina kadice+77,15
    RAZDužina kadice= Dužina + 60,63
    */
    sirina_dodatak_za_savijanje = 77.15;
    duzina_dodatak_za_savijanje = 60.63;
  } else if (tip === "STANDARDNA") {
    // ZA STANDARDNU
    /*
    Standardna kadica:
    RAZŠirina kadice= Širina kadice+176,1
    RAZDužina kadice= Dužina + 128,99
    */
    sirina_dodatak_za_savijanje = 176.1;
    duzina_dodatak_za_savijanje = 128.99;
  }
  let sirina_razvijena = sirina + sirina_dodatak_za_savijanje;
  let duzina_razvijena = duzina + duzina_dodatak_za_savijanje;


  //
  // Tako da, kada na osnovu unetih parametara dužina i širina, dobijemo razvijenu meru kadice. Onda dalje po sledećoj logici delimo dobijenu razvijenu meru kadice na dva dela (P1 i P2):
  //
  //
  let _is_jednodelna_varijanta = true;
  let _is_deljenje_sirine_na_pola = false;
  const K8 = sirina_razvijena;
  const L8 = duzina_razvijena;
  const C8 = 'OVDE_BROJ_CRTEZA';
  // =IF(L8>K8;IF(AND(L8<=2450;K8<1174);C8;"Ne pripada ovde");IF(AND(L8<=2450;K8<1700);C8;"Ne pripada ovde"))
  // const _slucaj_1 = XIF(L8 > K8, XIF(AND(L8 <= 2450, K8 < 1174), C8, "Ne pripada ovde"), XIF(AND(L8 <= 2450, K8 < 1700), C8, "Ne pripada ovde"));
  const _slucaj_1 = XIF(L8 > K8,
    XIF(AND(L8 <= 2450, K8 < 1174), C8, "Ne pripada ovde"),
    XIF(AND(L8 <= 2450, K8 < 1700), C8, "Ne pripada ovde")
  );
  if (duzina_razvijena >= sirina_razvijena) { // 1. Ako je RAZDužina kadice=>RAZŠirina kadice i RAZDužina kadice<=2450 AND RAZŠirina kadice<1174
    // Ako je RAZDužina kadice<RAZŠirina kadice i RAZDužina kadice<=2450 AND RAZŠirina kadice<1700
    // - onda se kadica ne deli. Proizvodi se iz jednog dela.
    if ((duzina_razvijena <= 2450 && sirina_razvijena < 1174)) {
      // "Ne pripada ovde"
    } else {
      _is_jednodelna_varijanta = true;
    }
  } else {
    if ((duzina_razvijena <= 2450 && sirina_razvijena < 1700)) {
      // "Ne pripada ovde"
    } else {
      _is_jednodelna_varijanta = true;
    }
  }
  //
  //
  // 2. Ako je RAZDužina kadice>2450 AND RAZŠirina kadice<=1174
  // =IF(AND(L8>2450;K8<=1174);C8&"-P1";"Ne pripada ovde")
  if ((duzina_razvijena > 2450 && sirina_razvijena < 1174)) {
    /*
    - Deo P1 
    Širina = RAZŠirina kadice 
    Dužina = 2450mm
    
    - Deo P2 
    Širina = RAZŠirina kadice 
    Dužina = RAZDužina kadice-2450mm
    */
    _is_jednodelna_varijanta = false;
    p1_raz_sirina = sirina_razvijena;
    p1_raz_duzina = 2450;
    // p2_raz_sirina = sirina_razvijena - korektivni_deo;
    p2_raz_sirina = sirina_razvijena;
    // p2_raz_duzina = duzina_razvijena - p1_raz_duzina;
    // p2_raz_duzina = duzina_razvijena - 2450;
    p2_raz_duzina = duzina_razvijena - p1_raz_duzina;
  } else {
    // "Ne pripada ovde"
  }
  //
  //
  // 3. Dva slučaja:
  // Prvi Ako je RAZDužina kadice=>RAZŠirina Kadice i RAZDužina kadice>=1000 AND RAZDužina kadice<=2450 AND RAZŠirina kadice>1174.
  if ((duzina_razvijena >= sirina_razvijena)) {
    if ((duzina_razvijena >= 1000 && duzina_razvijena <= 2450) && (sirina_razvijena > 1174)) {
      /*
      Prvi slučaj:
      - Deo P1 
      Širina = RAZŠirina kadice 
      Dužina = 1174mm

      - Deo P2 
      Širina = RAZŠirina kadice 
      Dužina = RAZDužina kadice-1174mm
      */
      _is_jednodelna_varijanta = false;
      p1_raz_sirina = sirina_razvijena;
      p1_raz_duzina = 1174;
      p2_raz_sirina = sirina_razvijena;
      // p2_raz_duzina = duzina_razvijena - 1174;
      p2_raz_duzina = duzina_razvijena - p1_raz_duzina;
    } else {
      // "Ne pripada ovde"
    }
  } else {
    // "Ne pripada ovde"
  }
  // U drugom slučaju RAZDužina kadice<=RAZŠirina i RAZDužina kadice>=1000 AND RAZDužina kadice<=2450 AND RAZŠirina kadice>1174 sistem treba da pošalje poruku
  // NJ: ispravka RAZDužina kadice<RAZŠirina
  if ((duzina_razvijena < sirina_razvijena)) {
    if ((duzina_razvijena >= 1000 && duzina_razvijena <= 2450) && (sirina_razvijena > 1174)) {
      /*
      Drugi slučaj Ovaj slučaj ne postoji u excelu, jer sam se setio u toku pisanja : 
      - Deo P1 
      Širina = RAZŠirina kadice /2
      Dužina = RAZDužina kadice
      
      - Deo P2 
      Širina = RAZŠirina kadice /2
      Dužina = RAZDužina kadice
      */
      _is_jednodelna_varijanta = false;
      _is_deljenje_sirine_na_pola = true;
      p1_raz_sirina = sirina_razvijena / 2;
      p1_raz_duzina = duzina_razvijena;
      p2_raz_sirina = sirina_razvijena / 2;
      p2_raz_duzina = duzina_razvijena;
    } else {
      // "Ne pripada ovde"
    }
  } else {
    // "Ne pripada ovde"
  }
  //
  // O korektivnom delu moramo da se dogovorimo.
  //

  // prave dimenzija (ne razvijene) za P1 i P2 delove u slucaju dvodelne
  let ter_visedelni_koliko_delova = null;
  if (_is_jednodelna_varijanta) {
    // nista
    ter_visedelni_koliko_delova = null;
  } else {
    ter_visedelni_koliko_delova = 2;
    if (tip === "PLITKA") {
      /*
      Plitka kadica
      Dužina
      P1 - razvijena 2-38,79 
      P2 - razvijena 2-21,84
      */
      // p1_dim_duzina = duzina_razvijena - 38.79;
      // p2_dim_duzina = duzina_razvijena - 21.84;
      p1_dim_duzina = p1_raz_duzina - 38.79;
      p2_dim_duzina = p2_raz_duzina - 21.84;
      p1_dim_sirina = sirina;
      p2_dim_sirina = sirina;
      if (_is_deljenje_sirine_na_pola === true) {
        p1_dim_sirina = p1_raz_sirina - sirina_dodatak_za_savijanje;
        p2_dim_sirina = p2_raz_sirina - sirina_dodatak_za_savijanje;
      }
      /*
      Plitka kadica
      Dužina
      P1 - razvijena 1-77,15 Ovaj podatak treba da je isti kao i parametar sirina, možeš i bez proračuna samo da ga uzmeš
      P2 - razvijena 1-77,15 Ovaj podatak treba da je isti kao i parametar sirina, možeš i bez proračuna samo da ga uzmeš
      
      Dim.2
      P1 - razvijena 2-38,79 
      P2 - razvijena 2-21,84
      */
      // p1_dim_duzina = sirina;
      // p2_dim_duzina = sirina;
      // p1_dim_sirina = duzina_razvijena - 38.79;
      // p2_dim_sirina = duzina_razvijena - 21.84;
    } else if (tip === "STANDARDNA") {
      /*
      Standardna kadica:
      Dužina
      P1 - razvijena 2-88,35
      P2 - razvijena 2-40,68
      */
      // p1_dim_duzina = duzina_razvijena - 88.35;
      // p2_dim_duzina = duzina_razvijena - 40.68;
      p1_dim_duzina = p1_raz_duzina - 88.35;
      p2_dim_duzina = p2_raz_duzina - 40.68;
      p1_dim_sirina = sirina;
      p2_dim_sirina = sirina;
      if (_is_deljenje_sirine_na_pola === true) {
        p1_dim_sirina = p1_raz_sirina - sirina_dodatak_za_savijanje;
        p2_dim_sirina = p2_raz_sirina - sirina_dodatak_za_savijanje;
      }
      /*
      Dužina
      P1 - razvijena 1-176,1 Ovaj podatak treba da je isti kao i parametar sirina, možeš i bez proračuna samo da ga uzmeš
      P2 - razvijena 1-176,1 Ovaj podatak treba da je isti kao i parametar sirina, možeš i bez proračuna samo da ga uzmeš
      
      Dim.2
      P1 - razvijena 2-88,35
      P2 - razvijena 2-40,68
      */
      // p1_dim_duzina = sirina;
      // p2_dim_duzina = sirina;
      // p1_dim_sirina = duzina_razvijena - 88.35;
      // p2_dim_sirina = duzina_razvijena - 40.68;
    }
  }


  const protobomp_superdata = {
    tip, duzina, sirina, odvodkondenzata,
    ter_visedelni_koliko_delova,
    _extra_siframodula: siframodula, // NOVO 2025-03-18
  };

  //
  // let _protobomp = protobomp_manipulator.init(terProtobompUtils_make_protobomp_manifest_terkk_latest("terkk$kadica_v2"), null);
  let _protobomp = protobomp_manipulator.init(terProtobompUtils_make_protobomp_manifest_terkk_latest("terkk$kadica_v2", { allow_root_btns: true }), protobomp_superdata);
  //
  //
  const _pbnode_dirty_enrich = _derivat_terkk_kadica_v2_pbnode_dirty_enrich;
  // ----- kreiranje sklopova
  //
  let _temp_sklop;
  let _temp_pbnode;
  _temp_sklop = {
    pbnode_family: 'terkk$kadica_v2/SKLOP_KADICA',
    naziv: '* Kadica SKLOP',
    kolicina: kolicina,
    operacija1: "OPZAV",
    rc1: "RCZAV",
  };
  _pbnode_dirty_enrich(_temp_sklop, protobomp_superdata, true);
  _temp_pbnode = terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP(_temp_sklop, { allow_delete: true }, 'SKLOP_KADICA');
  const { created_tempkey: sklop_kadica } = protobomp_manipulator.add(_protobomp, _temp_pbnode, null);
  //
  //
  if (_is_jednodelna_varijanta) {
    const item = {
      tempkey: 110,
      pbnode_family: 'terkk$kadica_v2/LIM',
      naziv: "? Kadica",
      kolicina: 1, // po komadu sledece operacije
      // identmaterijala: 'LC00000J',
      identmaterijala: kadica_materijal_lim,
      dimenzija1: sirina,
      dimenzija2: duzina,
      razvijenamera1: sirina_razvijena,
      razvijenamera2: duzina_razvijena,
      "operacija1": "OPSEC",
      "rc1": "RCPRBAM",
      "operacija2": "OPSAV",
      "rc2": "RCPRSER",
    };
    _pbnode_dirty_enrich(item, protobomp_superdata, true);
    const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
    protobomp_manipulator.add(_protobomp, pbnode, sklop_kadica);
  } else {
    // dvodelna varijanta
    if (true) {
      const item = {
        tempkey: 111,
        pbnode_family: 'terkk$kadica_v2/LIM_1_2',
        naziv: "? Kadica P1",
        kolicina: 1, // po komadu sledece operacije
        identmaterijala: kadica_materijal_lim,
        dimenzija1: p1_dim_sirina,
        dimenzija2: p1_dim_duzina,
        razvijenamera1: p1_raz_sirina,
        razvijenamera2: p1_raz_duzina,
        "operacija1": "OPSEC",
        "rc1": "RCPRBAM",
        "operacija2": "OPSAV",
        "rc2": "RCPRSER",
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_kadica);
    }
    if (true) {
      const item = {
        tempkey: 112,
        pbnode_family: 'terkk$kadica_v2/LIM_2_2',
        naziv: "? Kadica P2",
        kolicina: 1, // po komadu sledece operacije
        identmaterijala: kadica_materijal_lim,
        dimenzija1: p2_dim_sirina,
        dimenzija2: p2_dim_duzina,
        razvijenamera1: p2_raz_sirina,
        razvijenamera2: p2_raz_duzina,
        "operacija1": "OPSEC",
        "rc1": "RCPRBAM",
        "operacija2": "OPSAV",
        "rc2": "RCPRSER",
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_kadica);
    }
  }
  //
  const E4 = duzina;
  const E5 = sirina;
  const E6 = odvodkondenzata;
  if (true) {
    const item = {
      tempkey: 120,
      naziv: XIF(E6 === "3/4", 'NAVOJNI ZAVRSETAK OD CEVI  3/4" X 130mm/20mm FILTER CO', XIF(E6 === '1', 'NAVOJNI ZAVRSETAK OD CEVI  1" X 130mm/20mm  FILTER CO', "?")),
      kolicina: 1, //
      jm: tclocal.JM_KOM,
      terkategorija: "M",
      identcustom: XIF(E6 === '1', "A070000000000195", XIF(E6 === "3/4", "A070000000000198", "?")),
    };
    // item.naziv_materijala = terUtils_get_naziv_materijala_by_ident(item.identmaterijala);
    const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_MATERIJAL(item);
    protobomp_manipulator.add(_protobomp, pbnode, sklop_kadica);
  }
  if (true) {
    const item = {
      tempkey: 130,
      naziv: 'IZOLACIJA KAIFLEX PLOCA EF PL 06-R/SK 6mm',
      kolicina: derivatPoluproizvod_kadica_mat_lim_kolicina(tip, E4, E5), //
      jm: tclocal.JM_M2,
      terkategorija: "M",
      identcustom: "A060000000000005",
    };
    // item.naziv_materijala = terUtils_get_naziv_materijala_by_ident(item.identmaterijala);
    const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_MATERIJAL(item);
    protobomp_manipulator.add(_protobomp, pbnode, sklop_kadica);
  }
  if (true) {
    const item = {
      tempkey: 140,
      naziv: 'IZOLACIJA KAIFLEX TRAKA ST',
      kolicina: 0.30,
      jm: tclocal.JM_M2,
      terkategorija: "M",
      identcustom: "A060000000000017",
    };
    // item.naziv_materijala = terUtils_get_naziv_materijala_by_ident(item.identmaterijala);
    const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_MATERIJAL(item);
    protobomp_manipulator.add(_protobomp, pbnode, sklop_kadica);
  }

  //
  //
  return {
    svasta: {
      /*
      prb_kolikokulisauprigusivacu,
      prbkulisa_kolicina,
      prbnosac_kolicina,
      */
    },
    // _arr,
    _protobomp: _protobomp, //
  }; // TODO
};


export const derivatAutoCreateVirtel_kadica_priprema_ulaza = (p, vrstaprofila) => {
  // returnujemo jednostavan objekat sa svim ulaznim velicinama za derivat formulu
  const pods_input = {
    // vrstaprofila: vrstaprofila,
    naziv: p.naziv,
    tip: p.tip,
    duzina: p.duzina,
    sirina: p.sirina,
    odvodkondenzata: p.odvodkondenzata,
    siframodula: p.siframodula
  };
  return pods_input;
};


export const derivatAutoCreateVirtel_kadica = (pods_input) => {
  console.log('derivatAutoCreateVirtel_kadica(pods_input) ');
  console.log(pods_input);
  let z = {}; // rezultat
  let x = {}; // JOCKER promenjiva
  let xm = {}; // JOCKER promenjiva
  let xx = {}; // JOCKER promenjiva
  let xxm = {}; // JOCKER promenjiva
  let _derivat_key;
  let _mat;
  let _materijal_naziv;

  // promenljive iz excela
  const E10 = pods_input.naziv;
  console.log('E10', E10);
  const E2 = pods_input.tip;
  // const E3 = pods_input.vrstaprofila;
  const E4 = pods_input.duzina;
  const E5 = pods_input.sirina;
  const E6 = pods_input.odvodkondenzata;



  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);


  // derivat 1 
  // derivat local 1
  _derivat_key = "derivat1";
  x = {
    _derivat_key,
    virtelschemakey: 'terkk$kadica',
    virtelclass: "terkk$kadica.1",
    terkategorija: 'PP',
    // tergrupa: 'KADICA',
    jm: tclocal.JM_KOM,
    kolicina: 1,
    calculated_ident: null,
    multitranslator_lang: "terkk$kadica/LIM",
  };
  // x.naziv = _xlfn.CONCAT("KADICA ";E2;" ";E4;" x ";E5;" ODVOD ";E6;"""")
  x.naziv = "KADICA " + E2 + " " + E4 + " x " + E5 + " ODVOD " + E6 + '"';
  // x.naziv = E10;
  x.duzina = E4;
  x.sirina = E5;
  // x.tip = '';
  x = {
    ...x,
    ..._getParamsFromLib("terkk$kadica.1")
  }; // parametri na kraju imaju prioritet
  z[_derivat_key] = x;
  _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);


  // derivat local 1.1 // kadica.1.1
  _derivat_key = "derivat2";
  xx = {
    _derivat_key,
    virtelschemakey: 'terkk$kadica',
    virtelclass: "terkk$kadica.1.1",
    // terkategorija: 'PP',
    // tergrupa: 'LIM' // Kod kadice red kadica.1.1 treba da ima vrednost u koloni "Grupa" umesto KADICA da stoji LIM.
    jm: tclocal.JM_KOM,
    kolicina: SINGLE_PIECE_PER_NEXT_OPERATION_UNIT, // PO JEDNOM KOMADU SLEDECE OPERACIJE
    calculated_ident: null,
    naziv: '?',
    multitranslator_lang: "terkk$kadica/LIM",
  };
  xx.naziv = x.naziv;
  xx.duzina = E4;
  xx.sirina = E5;
  xx.tip = 'LC00000J';
  xx.termaterijal = 'LC00000J';
  console.log('pods_input.siframodula', pods_input.siframodula);
  xx.siframodula = pods_input.siframodula;
  xx.siframodula2 = 'pods_input.siframodula';
  xx.cnccrtez = derivatPoluproizvod_kadica_broj_crteza(pods_input.tip, pods_input.duzina, pods_input.sirina, pods_input.odvodkondenzata);
  xx = {
    ...xx,
    ..._getParamsFromLib("terkk$kadica.1.1")
  }; // parametri na kraju imaju prioritet
  _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xx);


  // derivat local 1.1.1
  _derivat_key = 'terkk$kadica$materijal_lim';
  // _mat = _derivat_demper_materijal1_by_pp(x);
  const _novo_kadica_materijal_lim_params = {
    // "virtelclass": "terkk$kadica$materijal_lim",
    // "terkategorija": "M",
    // "tergrupa": "LIM", // ???
    "ident": "LC00000J",
    // "naziv": "LIM SS 1.50 mm",
    "naziv": "LIM PROHROM 1.50",
    "tip": "", // TODO ???
    "jm": "m2",
  }; // TODO ove parametre treba prebaciti u biblioteku parametara
  _mat = {
    terkategorija: 'M',
    // virtelclass: 'terkk$kadica$materijal_lim',
    ..._getParamsFromLib("terkk$kadica$materijal_lim"),
    ..._novo_kadica_materijal_lim_params,
    calculated_ident: "LC00000J",
  };
  // _mat.kolicina = ROUND((E5 + 176) * (E4 + 131) * 0.000001, 2);
  // _mat.kolicina = ROUNDUP((E5 + 176) * (E4 + 131) * 0.000001, 2);
  _mat.kolicina = derivatPoluproizvod_kadica_mat_lim_kolicina(pods_input.tip, E4, E5);
  xxm = {
    ..._mat,
    _derivat_key,
    virtelschemakey: 'terkk$kadica$materijal1',
  };
  z[_derivat_key] = xxm;
  _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xxm);


  // ZATIM SLEDI JOS 3 MATERIJALA ZA SPOLJNUFIKSNUZALUZINA


  // derivat local 1.2 MATERIJAL
  _derivat_key = 'kadica_materijal1';
  // _mat = _derivat_demper_materijal1_by_pp(x);
  _mat = {
    _derivat_key,
    virtelschemakey: 'terkk$kadica$materijal1',
    terkategorija: 'M',
    naziv: 'TODO',
    jm: tclocal.JM_KOM,
    kolicina: 1,
  };
  _mat.calculated_ident = XIF(E6 === '1', "A070000000000195", XIF(E6 === "3/4", "A070000000000198", "?"));
  _mat.naziv = XIF(E6 === "3/4", 'NAVOJNI ZAVRSETAK OD CEVI  3/4" X 130mm/20mm FILTER CO', XIF(E6 === '1', 'NAVOJNI ZAVRSETAK OD CEVI  1" X 130mm/20mm  FILTER CO', "?"));
  xm = {
    ..._mat,
  };
  z[_derivat_key] = xm;
  _virbom_manipulator.add_on_top_graphlevel(virbom_ref, xm);


  // derivat local 1.3 MATERIJAL
  _derivat_key = 'kadica_materijal2';
  // _mat = _derivat_demper_materijal1_by_pp(x);
  _mat = {
    _derivat_key,
    virtelschemakey: 'terkk$kadica$materijal1',
    terkategorija: 'M',
    calculated_ident: 'A060000000000005',
    naziv: 'IZOLACIJA KAIFLEX PLOCA EF PL 06-R/SK 6mm',
    jm: tclocal.JM_M2,
    // kolicina: 0.94,
  };
  _mat.kolicina = derivatPoluproizvod_kadica_mat_lim_kolicina(pods_input.tip, E4, E5);
  xm = {
    ..._mat,
  };
  z[_derivat_key] = xm;
  _virbom_manipulator.add_on_top_graphlevel(virbom_ref, xm);


  // derivat local 1.4 MATERIJAL
  _derivat_key = 'kadica_materijal3';
  // _mat = _derivat_demper_materijal1_by_pp(x);
  _mat = {
    _derivat_key,
    virtelschemakey: 'terkk$kadica$materijal1',
    terkategorija: 'M',
    calculated_ident: 'A060000000000017',
    naziv: 'IZOLACIJA KAIFLEX TRAKA ST',
    jm: tclocal.JM_M2,
    kolicina: 0.30,
  };
  xm = {
    ..._mat,
  };
  z[_derivat_key] = xm;
  _virbom_manipulator.add_on_top_graphlevel(virbom_ref, xm);


  console.log(z);


  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  console.log('der_virbom_seq');
  console.log(virbom_seq);
  return virbom_seq;
};

